"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const installWorkspace_1 = require("../../../app/dist/installWorkspace");
const dist_1 = require("../../../fs/dist");
exports.toolDef = {
    name: 'loom_install',
    description: "Install or upgrade Loom into the workspace at LOOM_ROOT: creates .loom/, writes .loom/CLAUDE.md, creates CLAUDE-LOCAL.md once, patches the root CLAUDE.md to import both, and writes .mcp.json, loom/ctx.md, and settings. Idempotent — pass force to overwrite the regenerable files (.mcp.json, ctx, settings) when they already exist. Returns which files were created vs. skipped. This is the in-process equivalent of the `loom install` CLI command, so the VS Code extension can initialise a workspace through MCP instead of shelling out to a terminal.",
    inputSchema: {
        type: 'object',
        properties: {
            force: { type: 'boolean', description: 'Overwrite regenerable files (.mcp.json, ctx, settings) that already exist.' },
            migrate_mcp_command: { type: 'boolean', description: 'Migrate a legacy command:"loom" server in an existing .mcp.json to the canonical npx pin (semantic change — pass only after user consent).' },
        },
        required: [],
    },
};
async function handle(root, args) {
    const registry = new dist_1.ConfigRegistry();
    const result = await (0, installWorkspace_1.installWorkspace)({ force: args['force'], migrateMcpCommand: args['migrate_mcp_command'] }, { fs, registry, cwd: root });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
